"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "IAccessControl__factory", {
  enumerable: true,
  get: function get() {
    return _IAccessControl__factory.IAccessControl__factory;
  }
});
var _IAccessControl__factory = require("./IAccessControl__factory");